import * as React from "react";
import type { SVGProps } from "react";
const SvgSkis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#skis_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.55 0a7.42 7.42 0 0 0-4.36 1.85L7.732 6.312 7.71 6.29l-4-4a1.004 1.004 0 0 0-1.42 1.42l4 4 .023.022L.88 13.17a3 3 0 0 0 0 4.24 3 3 0 0 0 4.24 0l5.437-5.433 1.418 1.418L6.54 18.82a3 3 0 0 0 0 4.25 3 3 0 0 0 2.12.93 3 3 0 0 0 2.12-.88l5.449-5.477q.029.034.061.067l1.875 1.875-.705.705a1.002 1.002 0 0 0 .326 1.636 1 1 0 0 0 .384.074 1 1 0 0 0 .71-.29l.705-.705.705.705A1 1 0 0 0 21 22a1 1 0 0 0 .71-1.71l-.705-.705.705-.705a1.004 1.004 0 1 0-1.42-1.42l-.705.705-1.875-1.875a1 1 0 0 0-.072-.065l4.452-4.475c1.17-1.17 2.59-4.48 1.42-5.65a1.8 1.8 0 0 0-1.31-.44v.02a7.4 7.4 0 0 0-4.35 1.85l-4.454 4.446-1.418-1.418L16.44 6.1C17.61 4.92 19 1.61 17.85.44a1.8 1.8 0 0 0-1.3-.44m-.28 2A5.9 5.9 0 0 1 15 4.68l-2.816 2.824L10.78 6.1l-.001-.001L13.61 3.27A5.8 5.8 0 0 1 16.27 2M9.363 7.513 7.978 8.897 8 8.92l1.383 1.392 1.393-1.396zM2.29 14.58l4.247-4.243.003.003 1.41 1.41L3.71 16a1 1 0 0 1-1.639-.325 1 1 0 0 1 .219-1.095m18.39-4.24a6 6 0 0 0 1.25-2.66 5.9 5.9 0 0 0-2.67 1.24l-2.834 2.836 1.404 1.414.009.009zm-7.072 4.238 1.399-1.401 1.431 1.401-1.43 1.43L15 16l-1.39-1.42zm-1.42 1.42L7.95 20.24a1 1 0 0 0 0 1.41 1 1 0 0 0 1.41 0l4.247-4.243L12.19 16z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="skis_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSkis;
